import { Box, FormLabel, FormLabelProps, HStack, Text, Tooltip } from '@chakra-ui/react';
import { FcInfo } from 'react-icons/fc';

export interface IInfoLabelProps extends FormLabelProps {
	text: string;
	help: string;
	htmlFor?: string;
}

export default function InfoLabel(props: IInfoLabelProps) {
	return (
		<FormLabel {...props}>
			<HStack justifyContent="space-between" alignContent="center">
				<Text fontWeight={500}>{props.text}</Text>
				<Tooltip label={props.help} placement="left" hasArrow>
					<Box>
						<FcInfo />
					</Box>
				</Tooltip>
			</HStack>
		</FormLabel>
	);
}
